export class PaymentMethod {
    paymentMethodKey: string;
    paymentType: string;
    paymentTypeId: string;
    quoteNro?: number;
    paymentFee: number;
    cbuNumber: string;
    creditCardType: string;
    creditCardNumber: string;
    creditCardName?: string;
    firstDueDate: Date;
    collector: {
        code: string,
        description: string
    };
    sendCouponsBy: {
        code: string,
        description: string
    };
    paymentInstrumentId?: string;
    // for UI use only
    icon: string;

    finalAmount: number;
    quoteAmount: number;
    title: string;
    fee: number;

    constructor(data?: Partial<PaymentMethod>) {
        this.paymentMethodKey = null;
        this.paymentType = null;
        this.paymentFee = 0;
        this.cbuNumber = null;
        this.creditCardType = null;
        this.creditCardNumber = null;
        this.firstDueDate = new Date();
        this.collector = {
            code: null,
            description: null
        };
        this.sendCouponsBy = {
            code: null,
            description: null
        };
        this.icon = null;

        this.finalAmount = null;
        this.quoteAmount = null;
        this.title = null;
        this.fee = null;

        if (data) {
            Object.assign(this, data);
        }
    }
}
